// extracted by mini-css-extract-plugin
export default {"form__container":"styles_form__container__Z3Yac","form__container__buttons":"styles_form__container__buttons__naVsb"};